import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { LocaleSharedModule } from '@app/i18n/locale-shared.module';
import { FilesService } from '@core/services';
import { ChangableComponent } from '@models/changable.component';
import { User } from 'lingo2-models';
import { OnUiCoverModule } from 'onclass-ui';
import { OnUiCover } from 'onclass-ui/lib/modules/on-ui-cover/on-ui-cover.component';

@Component({
  selector: 'app-tutor-mini',
  templateUrl: './tutor-mini.component.html',
  styleUrls: ['./tutor-mini.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [LocaleSharedModule, CommonModule, OnUiCoverModule],
})
export class TutorMiniComponent extends ChangableComponent {
  @Input() set user(user: User) {
    this._user = new User(user);
    this.prepareCard();
  }

  public get user(): User {
    return this._user;
  }

  @Input() display_mode: string;
  @Input() hide_classes: boolean;
  @Output() clicked = new EventEmitter<User>();

  public avatar: OnUiCover;

  private _user: User;

  private prepareCard() {
    this.avatar = {
      img: FilesService.getFileUrlBySize(this.user.userpic_id),
      form: 'circle',
      type: 'avatar',
    };
    this.detectChanges();
  }
}
